import React, { useRef, useState } from "react";
import { MessageCircle, Send, Loader2 } from "lucide-react";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { api } from "../api";

export const InquiryReplies = ({ inquiry, onUpdated, onError }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [replyUrl, setReplyUrl] = useState("");
  const [error, setError] = useState("");
  const pending = useRef(false);
  const id = inquiry.id;
  const submit = async (event) => {
    event.preventDefault();
    if (pending.current || !text.trim()) return;
    pending.current = true; setBusy(true); setError("");
    const popup = window.open("about:blank", "_blank");
    if (popup) popup.opener = null;
    try {
      const result = await api.replyInquiry(id, text.trim());
      onUpdated(result.inquiry); setReplyUrl(result.whatsappUrl); setText("");
      if (popup && !popup.closed) popup.location.replace(result.whatsappUrl);
    } catch (err) {
      if (popup && !popup.closed) popup.close();
      if ([401, 403].includes(err?.response?.status)) onError(err);
      else setError("Could not save your reply. Please try again.");
    } finally { pending.current = false; setBusy(false); }
  };
  return <div className="mt-6 border-t border-black/10 pt-5">
    {(inquiry.replies || []).length > 0 && <div data-testid={`inquiry-reply-history-${id}`} className="mb-5 space-y-4">
      {inquiry.replies.map((reply) => <div key={reply.id} data-testid={`inquiry-saved-reply-${reply.id}`} className="border-l-2 border-orange-300 pl-3">
        <p data-testid={`inquiry-reply-text-${reply.id}`} className="text-sm whitespace-pre-wrap break-words">{reply.text}</p>
        <p data-testid={`inquiry-reply-author-${reply.id}`} className="text-xs text-neutral-500 mt-1 break-words">{reply.author} · {new Date(reply.createdAt).toLocaleString()}</p>
      </div>)}
    </div>}
    <form onSubmit={submit}>
      <Label htmlFor={`inquiry-reply-input-${id}`}>Reply to {inquiry.name}</Label>
      <Textarea id={`inquiry-reply-input-${id}`} data-testid={`inquiry-reply-input-${id}`} required maxLength={2000} disabled={busy} value={text} onChange={(e) => setText(e.target.value)} className="mt-2 min-h-24 bg-white" />
      {error && <p data-testid={`inquiry-reply-error-${id}`} role="alert" className="text-sm text-red-700 mt-3">{error}</p>}
      <Button data-testid={`inquiry-reply-submit-${id}`} disabled={busy || !text.trim()} type="submit" className="mt-3 orange-gradient text-white border-0 gap-2 h-auto min-h-10 py-2 whitespace-normal max-w-full">{busy ? <Loader2 className="w-4 h-4 shrink-0 animate-spin" /> : <Send className="w-4 h-4 shrink-0" />}{busy ? "Saving…" : "Save reply & open WhatsApp"}</Button>
    </form>
    {replyUrl && <p data-testid={`inquiry-reply-confirmation-${id}`} role="status" className="text-sm text-neutral-600 mt-4">Reply saved. Tap Send in WhatsApp to deliver it. <a data-testid={`inquiry-reply-reopen-${id}`} href={replyUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-orange-600 hover:text-orange-700"><MessageCircle className="w-4 h-4" />Open WhatsApp</a></p>}
  </div>;
};